// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-8d6801b0!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ConfigAuthority.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("3b723ee4", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-8d6801b0!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/user/ConfigAuthority.vue
// module id = 1145
// module chunks = 2